<!--eslint-disable-->
<template>
  <div class="padd30 seller-style relative">
    <h2 class="f18 fb normal gray_2">货品管理</h2>
    <div class="box20"></div>
    <div class="good-search">
      <el-input v-model.trim="good_name" class="mar10_r" placeholder="请输入内容"></el-input>
      <el-button type="primary" @click="searchGood">搜索</el-button>
    </div>
    <!-- @tab-click="handleClick" -->
    <el-tabs v-model="relationType" @tab-click="handleClick">
      <el-tab-pane label="全部货品" value="0">
        <div class="bor_f0 mar10-t">
          <div class="flex items-center b_f5 box60 bor_bottom_f0">
            <div class="w40 pad25-l">销售商品</div>
            <div class="pad25-l">采购商品</div>
          </div>
          <template v-if="goodsList.length">
            <div class="flex bor_bottom_f0" v-for="item in goodsList">
              <div class="w40 good-detail flex relative h-auto">
                <div class="mar-auto">
                  <div class="box30"></div>
                  <div class="flex pad15-tb">
                    <img class="good-change-icon" src="./images/good-change.png" alt="">
                    <img :src="item.picUrl" alt="">
                    <div class="flex1">
                      <p class="ellipsis w240">{{item.name}}</p>
                      <p class="f12">规格：{{item.spec}}</p>
                      <div class="box10"></div>
                      <p>
                        <span class="pad20-r">数量：1</span>
                        <span>价格：￥{{item.marketPriceStr}}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex1 flex">
                <div class="flex1" v-if="item.supplyGoodsRelationList && item.supplyGoodsRelationList.length > 0">
                  <!-- bor_bottom_f0 判断样式 商品添加字段判断是否展示底边框  -->
                  <template v-for="(purchaseGoods,index) in item.supplyGoodsRelationList">
                    <div class="flex flex1" :key="index" v-if="index < 3">
                      <div class="good-detail w75">
                        <div class="flex">
                          <div class="flex1 pad15-tb" v-bind:class="{'bor_bottom_f0' : (item.supplyGoodsRelationList.length - 1 > index && index != 2) || !item.isShowOrNone}">
                            <p class="lin_20 mar10-b">供应商：{{purchaseGoods.shopName}}</p>
                            <div class=" flex">
                              <img  :src="purchaseGoods.picUrl" alt="">
                              <div class="flex1">
                                <p class="ellipsis w200">{{purchaseGoods.purchaseGoodsName}}</p>
                                <p class="f12">规格：{{purchaseGoods.spec}}</p>
                                <div class="box10"></div>
                                <p>
                                  <span class="pad20-r">数量：{{purchaseGoods.purchaseGoodsQuantity}}</span>
                                  <span>价格：￥{{purchaseGoods.marketPriceStr}}</span>
                                </p>
                                <p>
                                  <span v-if="purchaseGoods.purchaseGoodsTaxRatio !== 0">税率： {{purchaseGoods.purchaseGoodsTaxRatio}} %</span>
                                  <span v-else>税率：免税</span>
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="flex w110 align_flex_end justify-center pointer flex_column" v-if="purchaseGoods.isDefault == 1 && item.supplyGoodsRelationList.length > 1">
                            <span @click="upGoodSetting(index,purchaseGoods,item)">编辑</span>
                          </div>
                          <div class="flex w110 align_flex_end justify-center pointer flex_column" v-else>
                            <span @click="upGoodSetting(index,purchaseGoods,item)">编辑</span>
                            <span class="pad10_t" @click="goodSetting(purchaseGoods,item)">取消关联</span>
                          </div>
                        </div>
                      </div>
                      <div class="flex flex1 items-center justify-around flex_column f12 text-center pad10-lr " v-bind:class="{'bor_bottom_f0' :  (item.supplyGoodsRelationList.length - 1 > index && index != 2) || !item.isShowOrNone}" v-if="purchaseGoods.isDefault == 1">
                        <span>默认为所有客户</br>(除已设置的客户之外)</span>
                      </div>
                      <div class="flex flex1 items-center justify-around flex_column f12 text-center pad10-lr" v-bind:class="{'bor_bottom_f0' :  (item.supplyGoodsRelationList.length - 1 > index && index != 2) || !item.isShowOrNone}" v-else>
                      <span v-if="purchaseGoods.customerNameList">
                        {{purchaseGoods.customerNameList.split(",")[0]}}等 {{purchaseGoods.customerNameList.split(',').length}}个客户
                      </span>
                        <el-button @click="openCustomerPop(purchaseGoods,item)">编辑客户</el-button>
                      </div>
                    </div>
                    <div class="flex flex1" v-bind:class="{'none' : item.isShowOrNone}" :key="index" v-if="index > 2">
                      <div class="good-detail w75">
                        <div class="flex">
                          <div class="flex1 pad15-tb" v-bind:class="{'bor_bottom_f0' :  item.supplyGoodsRelationList.length - 1 > index}">
                            <p class="lin_20 mar10-b">供应商：{{purchaseGoods.shopName}}</p>
                            <div class=" flex">
                              <img  :src="purchaseGoods.picUrl" alt="">
                              <div class="flex1">
                                <p class="ellipsis w200">{{purchaseGoods.purchaseGoodsName}}</p>
                                <p class="f12">规格：{{purchaseGoods.spec}}</p>
                                <div class="box10"></div>
                                <p>
                                  <span class="pad20-r">数量：{{purchaseGoods.purchaseGoodsQuantity}}</span>
                                  <span>价格：￥{{purchaseGoods.marketPriceStr}}</span>
                                </p>
                                <p>
                                  <span v-if="purchaseGoods.purchaseGoodsTaxRatio !== 0">税率： {{purchaseGoods.purchaseGoodsTaxRatio}} %</span>
                                  <span v-else>税率：免税</span>
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="flex w110 align_flex_end justify-center pointer flex_column" v-if="purchaseGoods.isDefault == 1">
                            <span @click="upGoodSetting(index,purchaseGoods,item)">编辑</span>
                          </div>
                          <div class="flex w110 align_flex_end justify-center pointer flex_column" v-else>
                            <span @click="upGoodSetting(index,purchaseGoods,item)">编辑</span>
                            <span class="pad10_t" @click="goodSetting(purchaseGoods,item)">取消关联</span>
                          </div>
                        </div>
                      </div>
                      <div class="flex flex1 items-center justify-around flex_column f12 text-center pad10-lr" v-bind:class="{'bor_bottom_f0' :  item.supplyGoodsRelationList.length - 1 > index}" v-if="purchaseGoods.isDefault == 1">
                        <span>默认为所有客户</br>(除已设置的客户之外)</span>
                      </div>
                      <div class="flex flex1 items-center justify-around flex_column f12 text-center pad10-lr" v-bind:class="{'bor_bottom_f0' :  item.supplyGoodsRelationList.length - 1 > index}" v-else>
                      <span v-if="purchaseGoods.customerNameList">
                        {{purchaseGoods.customerNameList.split(",")[0]}}等 {{purchaseGoods.customerNameList.split(',').length}}个客户
                      </span>
                        <el-button @click="openCustomerPop(purchaseGoods,item)">编辑客户</el-button>
                      </div>
                    </div>
                  </template>
                  <div class="w75 h45 text-center good-more bor_right_f0" v-if="item.supplyGoodsRelationList.length > 3">
                    <!-- 判断 商品少于三个展示添加，大于三个展示展开 unfold.png---展开   pack-up.png----收起 -->
                    <img class="pointer" src="./images/pack-up.png" alt="" v-if="!item.isShowOrNone" @click="isShowOrNone(item)">
                    <img class="pointer" src="./images/unfold.png" alt="" v-if="item.isShowOrNone"  @click="isShowOrNone(item)">
                  </div>
                  <div class="w75 h45 text-center good-more bor_right_f0">
                    <!-- 判断 商品少于三个展示添加，大于三个展示展开 unfold.png---展开   pack-up.png----收起 -->
                     <el-button icon="el-icon-plus" @click="addGoodSetting(item)">添加</el-button>
                  </div>
                </div>
                <div v-else class="flex1">
                  <div class="good-detail w75 h-100 flex items-center justify-center flex_column">
                    <div class="f12 pad5_b">暂无关联商品</div>
                    <el-button icon="el-icon-plus" @click="addGoodSetting(item)">添加</el-button>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div class="t_center pad30-t pad30-b" v-else>暂无数据</div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="未关联" value="1">
        <div class="bor_f0 mar10-t">
          <div class="flex items-center b_f5 box60 bor_bottom_f0">
            <div class="w40 pad25-l">销售商品</div>
            <div class="pad25-l">采购商品</div>
          </div>
          <template v-if="goodsList.length">
            <div class="flex bor_bottom_f0" v-for="item in goodsList">
              <div class="w40 good-detail flex relative h-auto">
                <div class="mar-auto">
                  <div class="box30"></div>
                  <div class="flex pad15-tb">
                    <img class="good-change-icon" src="./images/good-change.png" alt="">
                    <img :src="item.picUrl" alt="">
                    <div class="flex1">
                      <p class="ellipsis w240">{{item.name}}</p>
                      <p class="f12">规格：{{item.spec}}</p>
                      <div class="box10"></div>
                      <p>
                        <span class="pad20-r">数量：1</span>
                        <span>价格：￥{{item.marketPriceStr}}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex1">
                <div class="good-detail w75 h-100 flex items-center justify-center flex_column">
                  <div class="f12 pad5_b">暂无关联商品</div>
                  <el-button icon="el-icon-plus" @click="addGoodSetting(item)">添加</el-button>
                </div>
              </div>
            </div>
          </template>
          <div class="t_center pad30-t pad30-b" v-else>暂无数据</div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="已关联" value="2">
        <div class="bor_f0 mar10-t">
          <div class="flex items-center b_f5 box60 bor_bottom_f0">
            <div class="w40 pad25-l">销售商品</div>
            <div class="pad25-l">采购商品</div>
          </div>
          <template v-if="goodsList.length">
            <div class="flex bor_bottom_f0" v-for="item in goodsList">
              <div class="w40 good-detail flex relative h-auto">
                <div class="mar-auto">
                  <div class="box30"></div>
                  <div class="flex pad15-tb">
                    <img class="good-change-icon" src="./images/good-change.png" alt="">
                    <img :src="item.picUrl" alt="">
                    <div class="flex1">
                      <p class="ellipsis w240">{{item.name}}</p>
                      <p class="f12">规格：{{item.spec}}</p>
                      <div class="box10"></div>
                      <p>
                        <span class="pad20-r">数量：1</span>
                        <span>价格：￥{{item.marketPriceStr}}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex1 flex">
                <div class="flex1" v-if="item.supplyGoodsRelationList && item.supplyGoodsRelationList.length">
                  <!-- bor_bottom_f0 判断样式 商品添加字段判断是否展示底边框  -->
                  <template v-for="(purchaseGoods,index) in item.supplyGoodsRelationList">
                    <div class="flex flex1" :key="index" v-if="index < 3">
                      <div class="good-detail w75">
                        <div class="flex">
                          <div class="flex1 pad15-tb" v-bind:class="{'bor_bottom_f0' : (item.supplyGoodsRelationList.length - 1 > index && index != 2) || !item.isShowOrNone}">
                            <p class="lin_20 mar10-b">供应商：{{purchaseGoods.shopName}}</p>
                            <div class=" flex">
                              <img  :src="purchaseGoods.picUrl" alt="">
                              <div class="flex1">
                                <p class="ellipsis w200">{{purchaseGoods.purchaseGoodsName}}</p>
                                <p class="f12">规格：{{purchaseGoods.spec}}</p>
                                <div class="box10"></div>
                                <p>
                                  <span class="pad20-r">数量：{{purchaseGoods.purchaseGoodsQuantity}}</span>
                                  <span>价格：￥{{purchaseGoods.marketPriceStr}}</span>
                                </p>
                                <p>
                                  <span v-if="purchaseGoods.purchaseGoodsTaxRatio !== 0">税率： {{purchaseGoods.purchaseGoodsTaxRatio}} %</span>
                                  <span v-else>税率：免税</span>
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="flex w110 align_flex_end justify-center pointer flex_column" v-if="purchaseGoods.isDefault == 1 && item.supplyGoodsRelationList.length > 1">
                            <span @click="upGoodSetting(index,purchaseGoods,item)">编辑</span>
                          </div>
                          <div class="flex w110 align_flex_end justify-center pointer flex_column" v-else>
                            <span @click="upGoodSetting(index,purchaseGoods,item)">编辑</span>
                            <span class="pad10_t" @click="goodSetting(purchaseGoods,item)">取消关联</span>
                          </div>
                        </div>
                      </div>
                      <div class="flex flex1 items-center justify-around flex_column f12 text-center pad10-lr " v-bind:class="{'bor_bottom_f0' :  (item.supplyGoodsRelationList.length - 1 > index && index != 2) || !item.isShowOrNone}" v-if="purchaseGoods.isDefault == 1">
                        <span>默认为所有客户</br>(除已设置的客户之外)</span>
                      </div>
                      <div class="flex flex1 items-center justify-around flex_column f12 text-center pad10-lr" v-bind:class="{'bor_bottom_f0' :  (item.supplyGoodsRelationList.length - 1 > index && index != 2) || !item.isShowOrNone}" v-else>
                      <span v-if="purchaseGoods.customerNameList">
                        {{purchaseGoods.customerNameList.split(",")[0]}}等 {{purchaseGoods.customerNameList.split(',').length}}个客户
                      </span>
                        <el-button @click="openCustomerPop(purchaseGoods,item)">编辑客户</el-button>
                      </div>
                    </div>
                    <div class="flex flex1" v-bind:class="{'none' : item.isShowOrNone}" :key="index" v-if="index > 2">
                      <div class="good-detail w75">
                        <div class="flex">
                          <div class="flex1 pad15-tb" v-bind:class="{'bor_bottom_f0' :  item.supplyGoodsRelationList.length - 1 > index}">
                            <p class="lin_20 mar10-b">供应商：{{purchaseGoods.shopName}}</p>
                            <div class=" flex">
                              <img  :src="purchaseGoods.picUrl" alt="">
                              <div class="flex1">
                                <p class="ellipsis w200">{{purchaseGoods.purchaseGoodsName}}</p>
                                <p class="f12">规格：{{purchaseGoods.spec}}</p>
                                <div class="box10"></div>
                                <p>
                                  <span class="pad20-r">数量：{{purchaseGoods.purchaseGoodsQuantity}}</span>
                                  <span>价格：￥{{purchaseGoods.marketPriceStr}}</span>
                                </p>
                                <p>
                                  <span v-if="purchaseGoods.purchaseGoodsTaxRatio !== 0">税率： {{purchaseGoods.purchaseGoodsTaxRatio}} %</span>
                                  <span v-else>税率：免税</span>
                                </p>
                              </div>
                            </div>
                          </div>
                          <div class="flex w110 align_flex_end justify-center pointer flex_column" v-if="purchaseGoods.isDefault == 1">
                            <span @click="upGoodSetting(index,purchaseGoods,item)">编辑</span>
                          </div>
                          <div class="flex w110 align_flex_end justify-center pointer flex_column" v-else>
                            <span @click="upGoodSetting(index,purchaseGoods,item)">编辑</span>
                            <span class="pad10_t" @click="goodSetting(purchaseGoods,item)">取消关联</span>
                          </div>
                        </div>
                      </div>
                      <div class="flex flex1 items-center justify-around flex_column f12 text-center pad10-lr" v-bind:class="{'bor_bottom_f0' :  item.supplyGoodsRelationList.length - 1 > index}" v-if="purchaseGoods.isDefault == 1">
                        <span>默认为所有客户</br>(除已设置的客户之外)</span>
                      </div>
                      <div class="flex flex1 items-center justify-around flex_column f12 text-center pad10-lr" v-bind:class="{'bor_bottom_f0' :  item.supplyGoodsRelationList.length - 1 > index}" v-else>
                      <span v-if="purchaseGoods.customerNameList">
                        {{purchaseGoods.customerNameList.split(",")[0]}}等 {{purchaseGoods.customerNameList.split(',').length}}个客户
                      </span>
                        <el-button @click="openCustomerPop(purchaseGoods,item)">编辑客户</el-button>
                      </div>
                    </div>
                  </template>
                  <div class="w75 h45 text-center good-more bor_right_f0" v-if="item.supplyGoodsRelationList.length > 3">
                    <!-- 判断 商品少于三个展示添加，大于三个展示展开 unfold.png---展开   pack-up.png----收起 -->
                    <img class="pointer" src="./images/pack-up.png" alt="" v-if="!item.isShowOrNone" @click="isShowOrNone(item)">
                    <img class="pointer" src="./images/unfold.png" alt="" v-if="item.isShowOrNone"  @click="isShowOrNone(item)">
                  </div>
                  <div class="w75 h45 text-center good-more bor_right_f0">
                    <!-- 判断 商品少于三个展示添加，大于三个展示展开 unfold.png---展开   pack-up.png----收起 -->
                    <el-button icon="el-icon-plus" @click="addGoodSetting(item)">添加</el-button>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div class="t_center pad30-t pad30-b" v-else>暂无数据</div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <div class="box20"></div>
    <div class="t_right">
      <el-pagination background @current-change="handleCurrentChange"
        :current-page="currentPage" :page-size="6" layout="total, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
    <el-dialog
      title="供应商商品选择"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :before-close="setGoodCancel"
      width="1200px">
      <div class="setDialog relative">
        <p class="dialog-msg">温馨提示：目前支持销售商品与供应商商品一对多的关系绑定！</p>
        <p v-if="goodsList.length">
          <span class="pad20-r">当前商品：{{curSellGood.name}}</span>
          <span>售价：¥{{curSellGood.marketPriceStr}}</span>
        </p>
        <p class="pad10-t" v-if="curPurchaseGood.purchaseGoodsName">
          <span class="pad20-r">当前关联供应商：{{curPurchaseGood.shopName}}</span>
          <span class="pad20-r">当前关联商品：{{curPurchaseGood.purchaseGoodsName}}</span>
          <span class="pad20-r">售价：¥{{curPurchaseGood.marketPriceStr}}</span>
          <span>数量： {{curPurchaseGood.purchaseGoodsQuantity}}</span>
        </p>
        <div class="flex items-start flex-wrap mar20-t mar20-b">
          <div class="flex items-center">
            <div class="lable">供应商：</div>
            <el-select filterable v-model="supplierId" placeholder="请选择">
              <el-option v-for="item in supplierList" :key="item.shopIdStr" :label="item.name" :value="item.shopIdStr"> </el-option>
            </el-select>
          </div>
          <div class="flex items-center mar15-l">
            <div class="lable">商品名称：</div>
            <el-input placeholder="请输入商品名称" v-model.trim="search_name"></el-input>
          </div>
          <el-button class="mar15-l" icon="el-icon-search" type="primary" @click="searchSetGood">查询</el-button>
        </div>
        <el-table
          border
          class="setTable"
          ref="multipleTable"
          :data="searchList"
          max-height="500"
          tooltip-effect="dark"
          style="width: 100%">
          <el-table-column label="" width="65">
            <template slot-scope="scope">
                <el-radio :disabled="scope.row.isRelationType === '1'" :label="scope.row.goodsId" v-model="goodRadio" @change="radioChange(scope)">&nbsp</el-radio>
            </template>
          </el-table-column>
          <el-table-column
            label="商品"
            width="300">
            <template slot-scope="scope">
              <div class="flex table-good-details">
                <el-tooltip v-if="scope.row.isRelationType === '1'" class="item" effect="dark" content="已关联" placement="top-start">
                  <img :src="scope.row.picUrl" alt="">
                </el-tooltip>
                <img v-else :src="scope.row.picUrl" alt="">
                <div>
                  <p class="ellipsis w200">{{scope.row.name}}</p>
                  <p>规格：{{scope.row.spec}}</p>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="marketPriceStr"
            label="价格"
            width="120">
          </el-table-column>
          <el-table-column
            prop="status"
            label="状态"
            width="120">
            <template slot-scope="scope">
              <p>{{scope.row.status === 5 ? '上架' : '下架'}}</p>
            </template>
          </el-table-column>
          <el-table-column
            prop="shopName"
            label="供应商"
            width="200"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="num"
            width="200"
            label="比例设置">
            <template slot-scope="scope">
              <el-input placeholder="请输入" v-model.trim="scope.row.num" :disabled="goodRadio !== scope.row.goodsId" @input="inputChange(scope, $event)"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="taxRatio"
            width="150"
            label="商品税率">
            <template slot-scope="scope">
              <el-select v-model="scope.row.taxRatio" :disabled="goodRadio !== scope.row.goodsId" placeholder="请选择">
                <el-option
                  v-for="item in taxRatioOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
<!--              <el-input placeholder="请输入" v-model.trim="scope.row.taxRatio" :disabled="goodRadio !== scope.row.goodsId" @input="inputChange(scope, $event)"></el-input>-->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setGoodCancel">取 消</el-button>
        <el-button type="primary" @click="setGoodSure">确 定</el-button>
      </span>
    </el-dialog>
    <!--选择客户弹框-->
    <el-dialog
      title="选择客户"
      :visible.sync="customerPop.chooseClientVisible"
      :close-on-click-modal="false"
      width="735px"
      :show-close="false"
      custom-class="chooseClientPop">
      <div>
        <div class="clear ps_search_wrap">
          <span class="float-left pad15_r lin_30 inlineblock">客户名称</span>
          <div class="ps_search float-left">
            <el-input
              type="text"
              placeholder="请输入客户名称"
              v-model="customerPop.searchCustomer.name"
            >
            </el-input>
          </div>
          <div class="float-left client_pop_query" @click="listCustomer(1)">搜索</div>
        </div>
        <div class="box30"></div>
        <div class="clear ps_search_wrap">
          <span class="float-left pad15_r lin_30 inlineblock">客户分组</span>
          <div class="ps_search float-left">
            <el-select v-model="customerPop.searchCustomer.groupId" placeholder="请选择客户分组" clearable>
              <el-option
                v-for="item in customerPop.groupDataList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="box20"></div>
        <div class="clear ps_group_list">
          <div class="float-left client_list_all">
            <p>我的客户</p>
            <div class="client_list_pop_main">
              <ul class="clear">
                <!-- 客户-->
                <li v-for="(item,index) in customerPop.customerDataList" :key="index" @click="customerDialogSelect(item)">
                  <div class="client_list_mask" v-if="item.isCheck" v-html="'归属采购商品：'+item.attrName"></div>
                  <p class="group_item_name ellipsis_two">{{item.name}}</p>
                  <p>身份：{{item.targetType === 1 ? '个人' : '企业'}}</p>
                </li>
              </ul>
            </div>
          </div>
          <div class="float-right client_list_me">
            <p>已选客户</p>
            <div class="client_list_pop_main">
              <ul class="clear">
                <li v-for="(item,index) in conCustomerSel.customerSelList" :key="index">
                  <i class="iconfont icon-shibai fb" @click="removeSelectCustomer(item)"></i>
                  <p class="group_item_name ellipsis_two">{{item.name}}</p>
                  <p>身份：{{item.targetType === 1 ? '个人' : '企业'}}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="box20"></div>
      <el-pagination
        background
        @size-change="handleSizeChangeCustomer"
        @current-change="handleCurrentChangeCustomer"
        :current-page="customerPop.currentPageCustomer"
        :page-sizes="[6, 10, 20]"
        :page-size="customerPop.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="customerPop.totalCount">
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="customerDialogConfirm">确 认</el-button>
        <el-button @click="customerDialogClose">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Loading } from "element-ui";

export default {
  data() {
    return {
      good_name: "", // 搜索销售商品
      relationType: "0",
      shopId: "",
      goodsList: [], // 销售商品列表
      currentPage: 1,
      total: 0,
      dialogVisible: false, // 设置关联商品弹框
      supplierId: "", // 供应商id
      supplierList: [], // 设置关联商品供应商列表
      search_name: "", // 商品id
      searchList: [],
      goodRadio: "",
      loadingInstance: "",
      lastIndex: 0, // 上一个输入价格的商品索引
      curSetIndex: 0,
      curPurchaseGood: {},
      curSellGood:{},
      isAddOrEdit: 0,
      conCustomerSel: {},
      customerPop: {
        chooseClientVisible: false,
        searchCustomer: {
          name: '',
          phone: '',
          groupId: '',
          pageNum: 1,
          pageSize: 10,
        },
        customerDataList: [],
        customerSelList: [],
        currentPageCustomer: 1,
        groupDataList: [],
        pageSize: 6,
        totalCount: 0,
      },
      taxRatioOptions: [
        {
          value: 0,
          label: "免税"
        },
        {
          value: 3,
          label: "3%"
        },
        {
          value: 6,
          label: "6%"
        },
        {
          value: 9,
          label: "9%"
        },
        {
          value: 11,
          label: "11%"
        },
        {
          value: 13,
          label: "13%"
        }
      ]
    };
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
  }),
  created() {
    this.getQueryGoodsList();
    this.getGoodsSupplierList();
    this.getCustomerGroupList();
  },
  mounted() {},
  // 监听器
  filters: {},
  methods: {
    // 设置关联商品点击取消
    setGoodCancel() {
      this.supplierId = "";
      this.search_name = "";
      this.searchList = [];
      this.dialogVisible = false;
    },
    // 设置关联商品点击确定
    setGoodSure() {
      const { goodRadio, curSetIndex } = this;
      if (!goodRadio) {
        this.$message.warning("请先查询并选择商品");
        return;
      }
      const sellGoodsId = this.curSellGood.goodsId;
      const shopId = this.curSellGood.shopIds;
      const purchaseGoodsQuantity = this.searchList[curSetIndex].num;
      if (!purchaseGoodsQuantity) {
        this.$message.warning("请设置商品数量");
        return;
      }
      const purchaseGoodsTaxRatio = this.searchList[curSetIndex].taxRatio;
      if (!purchaseGoodsQuantity) {
        this.$message.warning("请设置商品税率");
        return;
      }
      this.loadingInstance = Loading.service({
        target: ".setDialog",
        lock: true,
        text: "商品设置中",
      });
      if (this.isAddOrEdit === 0) {
        this.$store
          .dispatch("relevance/goodsSupplierAdd", {
            shopId,
            sellGoodsId,
            purchaseGoodsQuantity,
            purchaseGoodsTaxRatio,
            purchaseGoodsId: goodRadio,
          })
          .then((data) => {
            this.loadingInstance && this.loadingInstance.close();
            if (data) {
              this.$message.success("设置成功！");
              this.supplierId = "";
              this.search_name = "";
              this.searchList = [];
              this.dialogVisible = false;
              this.getQueryGoodsList();
            }
          });
      } else {
        const purchaseGoodsIdOld = this.curPurchaseGood.purchaseGoodsId;
        this.$store
          .dispatch("relevance/goodsSupplierEdit", {
            shopId,
            sellGoodsId,
            purchaseGoodsIdOld,
            purchaseGoodsIdNew: goodRadio,
            purchaseGoodsQuantity,
            purchaseGoodsTaxRatio,
            purchaseGoodsId: goodRadio,
          })
          .then((data) => {
            this.loadingInstance && this.loadingInstance.close();
            if (data) {
              this.$message.success("设置成功！");
              this.supplierId = "";
              this.search_name = "";
              this.searchList = [];
              this.dialogVisible = false;
              this.getQueryGoodsList();
            }
          });
      }
    },
    // 设置关联商品搜索
    searchSetGood() {
      // this.goodRadio = "";
      this.searchList = [];
      this.getQueryGoodsListByParam();
    },
    // 点击设置关联商品
    goodSetting(purchaseGoods, sellGoods) {
      const purchaseGoodsId = purchaseGoods.purchaseGoodsId;
      const sellGoodsId = sellGoods.goodsId;
      const shopId = sellGoods.shopIds;
      this.$confirm("您是否要取消商品关联?", "提示").then(() => {
        this.$store
          .dispatch("relevance/goodsSupplierDel", {
            shopId,
            purchaseGoodsId,
            sellGoodsId,
          })
          .then((data) => {
            if (data) {
              this.$message.success("取消关联成功");
              this.getQueryGoodsList();
            }
          });
      });
    },
    addGoodSetting(sellGoods) {
      this.dialogVisible = true;
      this.isAddOrEdit = 0;
      this.curSellGood = sellGoods;
      this.goodRadio = "";
      this.curPurchaseGood = {};
      this.getQueryGoodsListByParam();
    },
    upGoodSetting(index, purchaseGoods, sellGoods) {
      this.dialogVisible = true;
      this.isAddOrEdit = 1;
      this.curSellGood = sellGoods;
      this.goodRadio = purchaseGoods.purchaseGoodsId;
      this.curPurchaseGood = purchaseGoods ? purchaseGoods : {};
      this.supplierId = purchaseGoods ? purchaseGoods.shopIdStr : "";
      this.search_name = purchaseGoods ? purchaseGoods.purchaseGoodsName : "";
      this.getQueryGoodsListByParam();
    },
    // 切换设置关联商品选择
    radioChange(scope) {
      const { lastIndex } = this;
      const { $index } = scope;
      this.curSetIndex = $index;
      const item = this.searchList[lastIndex];
      item.num = "";
      this.$set(this.searchList, lastIndex, item);
    },
    // 输入价格同步数据
    inputChange(scope) {
      const { $index, row } = scope;
      let value = this.searchList[$index].num;
      // eslint-disable-next-line
      value = value.replace(/[^\d^\.]+/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/^(\-)*(\d+)\.(\d\d\d).*$/,'$1$2.$3');
      const item = row;
      item.num = value;
      this.lastIndex = $index;
      this.$set(this.searchList, $index, item);
    },
    // 搜索商品列表
    searchGood() {
      this.relationType = "0";
      this.currentPage = 1;
      this.goodsList = [];
      this.getQueryGoodsList();
    },
    // 切换tab
    handleClick() {
      this.good_name = "";
      this.getQueryGoodsList();
    },
    // 获取商品列表
    getQueryGoodsList() {
      this.loadingInstance = Loading.service({
        lock: true,
        text: "数据加载中",
      });
      const { currentPage, relationType, good_name } = this;
      this.$store
        .dispatch("relevance/getQueryGoodsList", {
          pageNum: currentPage,
          name: good_name,
          relationType,
        })
        .then((res) => {
          this.loadingInstance && this.loadingInstance.close();
          const { goodsList, totalCount, shop } = res;
          this.goodsList = goodsList || [];
          this.goodsList.forEach((supplyGoods) => {
            this.$set(supplyGoods, 'isShowOrNone', true);
          })
          this.total = totalCount;
          this.shopId = shop.shopIdStr;
        });
    },
    isShowOrNone(sellGoods){
      sellGoods.isShowOrNone = !sellGoods.isShowOrNone;
    },
    // 获取供应商列表
    getGoodsSupplierList() {
      this.$store.dispatch("relevance/getGoodsSupplierList").then((data) => {
        this.supplierList = data;
      });
    },
    // 获取设置搜索的供应商商品列表
    getQueryGoodsListByParam() {
      this.loadingInstance = Loading.service({
        target: ".setTable",
        lock: true,
        text: "数据加载中",
      });
      const { search_name, supplierId, shopId } = this;
      this.$store
        .dispatch("relevance/getQueryGoodsListByParam", {
          name: search_name,
          shopId: supplierId,
          selfShopId: shopId,
        })
        .then((data) => {
          this.loadingInstance && this.loadingInstance.close();
          const { goodsList } = data;
          this.searchList = goodsList || [];
          this.searchList.forEach((item, index) => {
            item.num = undefined;
            item.isRelationType = "0";
            this.$set(this.searchList, index, {
              ...this.searchList[index],
              taxRatio: 0
            })
            this.curSellGood.supplyGoodsRelationList.forEach((supplyGoods) => {
              if (supplyGoods.purchaseGoodsId === item.goodsId) {
                item.isRelationType = "1";
                item.num = supplyGoods.purchaseGoodsQuantity;
                this.$set(this.searchList, index, {
                  ...this.searchList[index],
                  taxRatio:supplyGoods.purchaseGoodsTaxRatio
                })
              }
            })
            if (this.curPurchaseGood.purchaseGoodsId === item.goodsId) {
              item.isRelationType = "0";
              item.num = this.curPurchaseGood.purchaseGoodsQuantity;
              this.$set(this.searchList, index, {
                ...this.searchList[index],
                taxRatio:this.curPurchaseGood.purchaseGoodsTaxRatio
              })
              this.curSetIndex = index;
            }
          });
        });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getQueryGoodsList();
    },

    openCustomerPop(item,sellGoods) {
      this.curSellGood = sellGoods;
      this.curPurchaseGood = item;
      this.customerPop.currentPageCustomer = 1;
      this.customerPop.chooseClientVisible = true;
      this.conCustomerSel = JSON.parse(JSON.stringify(item));
      this.customerSelected = item.customerSelList || [];
      this.listCustomer(1);
    },
    handleSizeChangeCustomer(val) {
      this.customerPop.pageSize = val;
      this.listCustomer();
    },
    handleCurrentChangeCustomer(val) {
      this.customerPop.currentPageCustomer = val;
      this.listCustomer();
    },
    customerDialogConfirm() {
      const sellGoodsId = this.curSellGood.goodsId;
      const purchaseGoodsId = this.curPurchaseGood.purchaseGoodsId;
      const shopId = this.curSellGood.shopIds;
      this.$store.dispatch('relevance/saveCustomer', {
        shopId,
        sellGoodsId,
        purchaseGoodsId,
        customerEntityResList: this.conCustomerSel.customerSelList,
      }).then((data) => {
        console.log(data);
        this.curSellGood = {};
        this.curPurchaseGood = {};
        this.customerPop.chooseClientVisible = false;
        this.getQueryGoodsList();
      });
    },
    customerDialogClose() {
      this.customerPop.chooseClientVisible = false;
    },
    getCustomerGroupList() {
      this.$store.dispatch('shop/shop/getCustomerGroupList').then((data) => {
        this.groupDataList = [];
        if (data) {
          this.customerPop.groupDataList = data;
        }
      });
    },
    listCustomer(type) {
      const { searchCustomer } = this.customerPop;
      searchCustomer.pageNum = this.customerPop.currentPageCustomer;
      searchCustomer.pageSize = this.customerPop.pageSize;
      if (type === 1) { // 搜索
        searchCustomer.pageNum = 1;
      }
      this.$store.dispatch('shop/shop/listCustomer', this.$qs.stringify(searchCustomer)).then((data) => {
        const newData = data || {};
        this.customerPop.customerDataList = newData.data || [];
        this.customerPop.totalCount = newData.count || 0;
        if (this.customerPop.customerDataList.length > 0) {
          this.customerPop.customerDataList.forEach((customer) => {
            this.$set(customer, 'isCheck', false);
            this.curSellGood.supplyGoodsRelationList.forEach((supplyGoods) => {
              supplyGoods.customerSelList.forEach((item) => {
                if (item.targetIdStr == customer.targetIdStr && this.curPurchaseGood.purchaseGoodsId != supplyGoods.purchaseGoodsId) {// eslint-disable-line
                  customer.isCheck = true;
                  this.$set(customer, 'attrName', supplyGoods.purchaseGoodsName);
                }
              });
            });
          });
        }
        if (type === 2) {
          if (this.customerPop.customerDataList.length === 0) {
            this.$message.error('无客户数据,请添加客户');
            return;
          }
          this.customerPop.chooseClientVisible = true;
        }
      });
    },
    customerDialogSelect(item) {
      if (item.isCheck) {
        return;
      }
      if (this.conCustomerSel.customerSelList.some(e => e.targetIdStr === item.targetIdStr)) {
        console.log(1);
      } else {
        this.conCustomerSel.customerSelList.push(item);
      }
    },
    removeSelectCustomer(item) {
      this.conCustomerSel.customerSelList.splice(this.conCustomerSel.customerSelList.indexOf(item), 1);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "index";
</style>
